export default {
	linkGroups: [
		{
			title: "Shop",
			links: [
				{
					copy: "Current Promo Offers",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Print A Document",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Shop All Products",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Shop All Services",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				}
			]
		},
		{
			title: "About",
			links: [
				{
					copy: "About Us",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Careers",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Policies & Legal",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Sustainability Commitment",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				}
			]
		},
		{
			title: "Account",
			links: [
				{
					copy: "My Account",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Re-Orders",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Store Locator",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				}
			]
		},
		{
			title: "Help & Support",
			links: [
				{
					copy: "My Account",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Contact Us",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "F.A.Q",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Track Your Order",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				}
			]
		},
		{
			title: "Community",
			links: [
				{
					copy: "Preferred Customer",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Staples Studio",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				},
				{
					copy: "Staples Spotlight",
					url: "www.google.com",
					altText: "testalt",
					target: "external" as const
				}
			]
		}
	],
	brandLogo: {
		imageUrl:
			"//staples-canada-dev4.myshopify.com/cdn/shop/t/2/assets/staples_logo_red_en.svg?v=30512713834202346341679407782",
		href: "https://www.staplescopyandprint.ca/",
		altText: "staples copy and print",
		target: "external" as const
	},
	socials: {
		title: "Join us on",
		links: [
			{
				icon: "amex",
				href: "https://www.staplescopyandprint.ca/",
				altText: "staples copy and print",
				target: "external" as const
			},
			{
				icon: "amex",
				href: "https://www.staplescopyandprint.ca/",
				altText: "staples copy and print",
				target: "external" as const
			},
			{
				icon: "amex",
				href: "https://www.staplescopyandprint.ca/",
				altText: "staples copy and print",
				target: "external" as const
			}
		]
	},
	externalLinks: [
		{
			copy: "Privacy Policy",
			url: "www.google.com",
			altText: "testalt",
			target: "external" as const
		},
		{
			copy: "Help Centre",
			url: "www.google.com",
			altText: "testalt",
			target: "external" as const
		}
	],
	legalese:
		"© 2023. Staples Canada ULC, All Rights Reserved. This Website is intended only for use by Canadian residents.",
	languageParams: [
		{
			language: "English",
			onClick: () => alert("clicked english")
		},
		{
			language: "French",
			onClick: () => alert("clicked french")
		}
	],
	footerVisibility: {
		hideLinks: false,
		hideBrandLogo: false,
		hideSocials: false,
		hideSubbrands: false,
		hideExternalLinks: false,
		hideLegalese: false,
		hideLanguageParams: false
	}
};
